import React, { useContext } from 'react';
import { PHASE, SETTINGS } from '../../constants';
import { getAssetUrlsFromId } from '../../manifest';
import { LazySuspenseContext } from '../../suspense';
import { getExport } from '../../utils';
import { LoaderError } from '../errors/loader-error';

function load(moduleId, loader) {
  try {
    return getExport(loader());
  } catch (err) {
    throw new LoaderError(moduleId, err);
  }
}

export function createComponentServer(_ref) {
  var dataLazyId = _ref.dataLazyId,
      defer = _ref.defer,
      loader = _ref.loader,
      moduleId = _ref.moduleId,
      ssr = _ref.ssr;
  return function (props) {
    var _getAssetUrlsFromId;

    var Resolved = ssr ? load(moduleId, loader) : null;

    var _useContext = useContext(LazySuspenseContext),
        fallback = _useContext.fallback;

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      type: "hidden",
      "data-lazy-begin": dataLazyId
    }), defer !== PHASE.LAZY && ((_getAssetUrlsFromId = getAssetUrlsFromId(SETTINGS.MANIFEST, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map(function (url) {
      return /*#__PURE__*/React.createElement("link", {
        key: url,
        rel: defer === PHASE.PAINT ? 'preload' : 'prefetch',
        href: url,
        crossOrigin: SETTINGS.CROSS_ORIGIN,
        as: "script"
      });
    })), Resolved ? /*#__PURE__*/React.createElement(Resolved, props) : fallback, /*#__PURE__*/React.createElement("input", {
      type: "hidden",
      "data-lazy-end": dataLazyId
    }));
  };
}